module.exports = __webpack_public_path__ + "img/smart-meter.0d237b44.png";